// DiscoverSkeleton — mirrors the real discover page so the swap doesn't jump.
// Rendered inside .sf-disc-root/.sf-disc-page so it inherits the page's
// tokens, light spill and paddings rather than re-stating them.
import "./discoverSkeleton.css";

export default function DiscoverSkeleton() {
	return (
		<div className="sf-disc-root sf-dsk">
			<div className="sf-disc-page">
				{/* HEADER */}
				<div className="sf-dsk-box sf-dsk-eyebrow" />
				<div className="sf-dsk-box sf-dsk-title" />
				<div className="sf-dsk-box sf-dsk-sub" />

				{/* CONTROLS */}
				<div className="sf-dsk-controls">
					<div className="sf-dsk-chips">
						{Array.from({ length: 3 }).map((_, i) => (
							<div className="sf-dsk-box sf-dsk-chip" key={i} />
						))}
					</div>
					<div className="sf-dsk-box sf-dsk-mapbtn" />
				</div>

				{/* RESULTS */}
				<div className="sf-dsk-list">
					{Array.from({ length: 3 }).map((_, card) => (
						<div className="sf-dsk-card" key={card}>
							<div className="sf-dsk-box sf-dsk-media" />

							<div className="sf-dsk-body">
								<div className="sf-dsk-box sf-dsk-name" />
								<div className="sf-dsk-box sf-dsk-addr" />
								<div className="sf-dsk-box sf-dsk-pill" />

								{Array.from({ length: 3 }).map((_, row) => (
									<div className="sf-dsk-row" key={row}>
										<div className="sf-dsk-row-copy">
											<div className="sf-dsk-box sf-dsk-service" />
											<div className="sf-dsk-box sf-dsk-price" />
										</div>
										<div className="sf-dsk-box sf-dsk-btn" />
									</div>
								))}
							</div>

							<div className="sf-dsk-foot">
								<div className="sf-dsk-box sf-dsk-footline" />
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
